import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useApp } from "../context/AppContext";
import { PageHeader, NativeSelect } from "../components/Common";
import { WeeklyHours, TimeOff } from "../components/Availability";

export default function Availability() {
  const { user, staff, locations, can } = useApp();
  const [params] = useSearchParams();
  const manage = can("staff.write");
  const [uid, setUid] = useState((manage && params.get("user")) || user.id);
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get(`/staff/${uid}/availability`).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))), [uid]);
  useEffect(() => { setD(null); load(); }, [load]);
  const pros = staff.filter((s) => s.active && ["professional", "owner"].includes(s.role));
  return (
    <div className="space-y-6" data-testid="availability-page">
      <PageHeader eyebrow="Working hours" title="Availability">
        {manage && <NativeSelect testId="availability-user-select" value={uid} onChange={setUid} options={pros.map((p) => ({ value: p.id, label: p.name }))} />}
      </PageHeader>
      <p className="text-sm text-muted-foreground -mt-4 max-w-2xl">Set the hours you work at each location. Online booking, the staff calendar and WhatsApp booking only offer times inside these hours and outside time off. Home-visit hours are set separately in Home visits.</p>
      {!d ? <p className="text-muted-foreground">Loading…</p> : <>
        <WeeklyHours uid={uid} data={d} locations={locations} onSaved={load} />
        <TimeOff uid={uid} items={d.time_off} onChanged={load} />
      </>}
    </div>
  );
}
